export default __webpack_public_path__ + "static/media/rishabh.922461d5.webp";